const POLL_INTERVAL_MS = 1000;
const MAX_POLLS = 30;

const request = (options) => new Promise((resolve, reject) => {
  $.ajax({ dataType: "json", ...options }).done(resolve).fail((_jqXHR, textStatus, errorThrown) => reject(new Error(`${textStatus} ${errorThrown}`)));
});

const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// The job splits text into pieces and drops the ones it can't cloze, so only the word is taken from it.
// Like QuickCloze.get_cloze_text, a whole-word match wins over the first occurrence.
const clozeFirstWord = (text, result) => {
  const word = result?.[0]?.text.match(/\{\{(.+?)\}\}/)?.[1];
  if (!word || !text.includes(word)) return "";
  const wholeWord = new RegExp(`(?<![\\p{L}\\p{N}_])${escapeRegExp(word)}(?![\\p{L}\\p{N}_])`, "u");
  return text.replace(wholeWord.test(text) ? wholeWord : word, (match) => `{{${match}}}`);
};

export default async function quickCloze(quickClozeUrl, text, { isCancelled }) {
  const job = await request({ data: { text }, method: "post", url: quickClozeUrl });
  if (job.errors) throw new Error(job.errors);

  for (let poll = 0; poll < MAX_POLLS; poll++) {
    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
    if (isCancelled()) return "";
    const tracker = await request({ url: job.url });
    if (tracker.status === "complete") return clozeFirstWord(text, tracker.result);
    if (tracker.status === "error") throw new Error(tracker.error);
  }
  return "";
}
